<template>
  <div :class="`promptWrap  ${isNight ? 'promptWrap_dark' : ''}`" v-html="ruleDesc"></div>
</template>

<script>
export default {
  props: ['ruleDesc', 'isNight'],
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="stylus">
.promptWrap {
  margin: 1.29rem 0.6rem 0.3rem 0.72rem;
  line-height: 0.42rem;
  font-size: 0.36rem;
  color: rgba(0, 0, 0, 0.55);
  background-color: #fafafa;
}
.promptWrap p {
  margin: 1.29rem 0.6rem 0.3rem 0.72rem;
  line-height: 0.42rem;
  font-size: 0.36rem;
  color: rgba(0, 0, 0, 0.55);
  background-color: #fafafa;
}
.promptWrap_dark {
  background-color: #000000;
  color: rgba(255, 255, 255, 0.55);
}
</style>


// WEBPACK FOOTER //
// src/pages/inviteCodePage/components/inviteCodeRule.vue